import React from 'react';
import PropTypes from 'prop-types';

class Logout extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    const { token } = this.props.auth;
    this.props.logout(token);
    this.props.signOut(token);
    this.props.router.replace('/');
  }

  render() {
    return (
      <h1>Logged Out.</h1>
    );
  }
}

Logout.propTypes = {
  router: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  logout: PropTypes.func.isRequired,
};

export default Logout;
